module.exports = __webpack_public_path__ + "img/power-dev-1_2x.485daf16.png";